var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5621,
    cy: 27.9871,
    r: 21.7379,
    transform: "rotate(-17.5184 27.5621 27.9871)",
    fill: "#193676"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.834 38.3516C30.2832 38.5225 29.6873 38.4698 29.1751 38.205C28.6628 37.9401 28.2753 37.4844 28.0963 36.9362L32.2423 35.6275C32.3322 35.9038 32.3665 36.1952 32.343 36.4848C32.306 36.8346 32.1864 37.1706 31.994 37.4652C31.8016 37.7598 31.542 38.0044 31.2365 38.1789L31.1889 38.194C31.0757 38.2573 30.9569 38.31 30.834 38.3516ZM38.1444 32.6248L21.5606 37.8595L20.9063 35.7865L22.6521 34.0957L20.8527 28.395C20.3365 26.9499 20.2087 25.3946 20.4821 23.8846C20.6303 23.185 20.9253 22.5248 21.3474 21.9476C21.7695 21.3703 22.3092 20.8891 22.9309 20.5357L22.2177 18.2762L26.3636 16.9675L27.0768 19.2271C29.9508 19.0197 32.1578 20.8807 33.2905 24.469L35.0899 30.1697L37.49 30.5518L38.1444 32.6248ZM37.2417 22.6519L35.1688 23.3062C34.7032 21.9974 33.9541 20.8077 32.9751 19.8222C31.9961 18.8367 30.8113 18.0798 29.5056 17.6056L30.5095 15.6589C32.0537 16.232 33.4456 17.1519 34.5781 18.3478C35.7497 19.5862 36.6561 21.0508 37.2417 22.6519ZM18.6161 28.5311L16.5431 29.1854C16.103 27.5384 16.0047 25.8187 16.2531 24.1321C16.4938 22.5028 17.1054 20.9504 18.0406 19.5947L19.9803 20.6123C19.1833 21.7501 18.6477 23.05 18.4118 24.419C18.176 25.788 18.2457 27.1922 18.6161 28.5311Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.b4d61877830d7aeb15a442055030d64e.svg";
export { ForwardRef as ReactComponent };